import { render, staticRenderFns } from "./SwiperAutoplay.vue?vue&type=template&id=8caa8d58"
import script from "./SwiperAutoplay.vue?vue&type=script&lang=js"
export * from "./SwiperAutoplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports